/// <reference path='Utilities/_reference.ts' />

module YVR.FlightTable {
	// Dependencies
	import date = YVR.Utilities.Dates;
	import events = YVR.Utilities.Events;
	import logger = YVR.Utilities.Logger;
	import i18n = YVR.Utilities.I18n;
	import mq = YVR.Utilities.MediaQueries;
	import urls = YVR.Utilities.Urls;

	// Default options
	const options = {
		cutoff: null,
		date: null,
		dateLabel: null,
		error: null,
		flightType: null,
		hasRun: false,
		isEmpty: null,
		query: null,
		serviceUrl: `/${i18n.getCurrentLanguage()}/_api/Flights`,
		//serviceUrl: 'http://yvrsc.dev.local/files/Flights-Table.json',	//for local testing
		showPreviousFlights: null,
		top: null
	};

	// CSS Classes
	const classes = {
		block: 'yvr-flights',
		body: 'yvr-flights__body',
		button: 'yvr-tab-switcher__button',
		clearButton: 'yvr-flights__button--clear',
		collapseButton: 'yvr-flights__toggle-flight',
		input: 'yvr-flights__input',
		form: 'yvr-flights__search',
		loading: 'yvr-flights--loading',
		table: 'yvr-table',
		searchButton: 'yvr-flights__search-button',
		status: 'yvr-flights__status',
		refreshButton: 'yvr-flights__button--refresh',
		row: 'yvr-flights__row',
		rowButton: 'yvr-flights__row--button',
		rowEarlier: 'yvr-flights__row--earlier',
		rowExpanded: 'yvr-flights__row--expanded',
		rowHidden: 'yvr-flights__row--hidden',
		toggles: 'yvr-form__toggle',
		viewAll: 'yvr-flights__view-all',
		viewEarlier: 'yvr-flights__button--view-earlier'
	};

	// Cached jQuery elements
	const elements = {
		block: $(`.${classes.block}`),
		body: $('body'),
		window: $(window)
	};

	//
	const cityMapping = {
		'london': 'lndn',
		'lon': 'ln',
		'lond': 'lnd',
		'londo': 'lnd'
	};


	// Cached data calls
	let cache = {
		date: null,
		hasEarlierFlights: null,
		query: null
	};


	function main() {
		console.log('getting flight-table');
		options.date = elements.block.data('flight-date');
		options.dateLabel = elements.block.data('flight-date-label');
		options.flightType = elements.block.data('flight-type');
		options.top = elements.block.data('flight-top');
		options.cutoff = elements.block.data('flight-cutoff');
		options.query = urls.getQueryStringParameter('q');
		options.showPreviousFlights = !options.top;

		// Add initial blank table to page
		renderFlights(options);

		runFlights();

		if (options.top) {
			eventNextFlightsBindings();
		} else {
			eventAllFlightsBindings();
		}

		// Refresh the page
		elements.block.on('click', `.${classes.refreshButton}`, e => {
			e.preventDefault();

			options.error = false;

			main();
		});

		bindPassengerJourneyLinks();
	}

	//#region Flights

	/**
	 * Get and render the flight table, removing any previous
	 */
	function runFlights() {
		if (elements.block.length) {
			if (!elements.block.hasClass('disable-api')) {

				elements.block.addClass(classes.loading);

				getFlights()
					.then(transformFlightData)
					.then(filterFlightData)
					.then(renderFlights)
					.then(runFlightSearch)
					.then(getFlightCookie)
					.fail(() => {
						logger.error('[flights][runFlights] An error occured retrieving the next flight data.');

						options.error = true;
						options.isEmpty = false;

						renderFlights(options);
					});
			} else {
				renderFlights(options);
			}
		}
	}


	/**
	 * Returns the next flight URL parameters.
	 * @returns {obj} An object of URL parameter data for the flight service.
	 */
	function getNextFlightsData() {
		const now = date.getCurrentTime().startOf('minute');
		const nowEDM = date.formatEDMTime(now);

		return {
			'$filter': `FlightScheduledTime gt DateTime'${nowEDM}' and FlightType eq '${options.flightType}'`,
			'$orderby': 'FlightScheduledTime asc',
			'$top': options.top
		};
	}


	/**
	 * Returns the all flight URL parameters.
	 * @returns {obj} An object of URL parameter data for the flight service.
	 */
	function getAllFlightsData() {
		const dateSelected = $(`.${classes.toggles}:checked`);
		options.date = dateSelected.val();
		options.dateLabel = dateSelected.next().text();
		options.query = elements.block.find(`.${classes.input}`).val();

		const offset = options.date === 'Today' ? 0 : 1;

		const start = date.getCurrentTime().startOf('day').add(offset, 'day');
		const startEDM = date.formatEDMTime(start);

		const end = date.getCurrentTime().startOf('day').add(offset + 1, 'day');
		const endEDM = date.formatEDMTime(end);
		if ($('.yvr-flights__table ').hasClass('wifi')) {
			return {
				'$filter': "((FlightScheduledTime gt DateTime'" + startEDM + "' and FlightScheduledTime lt DateTime'" + endEDM + "' and FlightType eq '" + options.flightType + "' and FlightStatus ne '" + 'Departed' + "') or (FlightEstimatedTime gt DateTime'" + startEDM + "' and FlightEstimatedTime lt DateTime'" + endEDM + "' and FlightType eq '" + options.flightType + "' and FlightType eq '" + 'Departed' + "'))",
				'$orderby': 'FlightScheduledTime asc'
			};
		} else {
			return {
				'$filter': "((FlightScheduledTime gt DateTime'" + startEDM + "' and FlightScheduledTime lt DateTime'" + endEDM + "' and FlightType eq '" + options.flightType + "') or (FlightEstimatedTime gt DateTime'" + startEDM + "' and FlightEstimatedTime lt DateTime'" + endEDM + "' and FlightType eq '" + options.flightType + "'))",
				'$orderby': 'FlightScheduledTime asc'
			};
		}
	}


	/**
	 * Get the latest flight data from the flight services.
	 * @returns {obj} A jQuery promise that resolves with data from the flight service.
	 */
	function getFlights() {
		console.log('getting flights');
		return $.ajax({
			url: options.serviceUrl,
			type: 'GET',
			data: options.top ? getNextFlightsData() : getAllFlightsData(),
			success(data) {
				logger.log('[flights][getFlights] Successfully retrieved next flight data.');
			}
		});
	}


	/**
	 * Transform the data from the web service to be more user and template friendly.
	 * @returns {obj} A jQuery promise that resolves with transformed flight data.
	 */
	function transformFlightData(data) {
		data.date = options.date;
		data.dateLabel = options.dateLabel;
		data.flightType = options.flightType;
		data.query = options.query;

		const now = date.getCurrentTime();
		const earlier = now.subtract(options.cutoff, 'minutes');

		const hash = window.location.hash;
		let id = 0;

		if (hash) {
			id = parseInt(hash.replace('#', ''), 10);
		}

		if (data.value) {
			// Loop through each flight
			for (const flight of data.value) {
				if (options.showPreviousFlights) {
					const estimate = date.convertTime(flight.FlightEstimatedTime);

					if (estimate.isBefore(earlier)) {
						flight.Earlier = true;
						data.hasEarlierFlights = true;
					}
				}

				if (!options.hasRun && id === flight.FlightID) {
					flight.expand = true;
				}

				if ((window as any).moment(flight.FlightScheduledTime).get('date') !== (window as any).moment(flight.FlightEstimatedTime).get('date')) {
					flight.differentDates = true;
				}

				if (flight.FlightScheduledTime === flight.FlightEstimatedTime) {
					flight.FlightEstimatedTime = null;
				}
			}
		}

		options.hasRun = true;

		// Keep this data as cached
		cache = $.extend({}, data);

		return data;
	}

	// Removes accents from words
	function removeDiacritics(str) {
		return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
	}

	/**
	 * Filter the filter data and re-render the table
	 */
	function filterFlightData(data) {

		let query = data.query;

		if (query && query.length) {
			const filteredData = {
				dateLabel: data.dateLabel,
				flightType: data.flightType,
				isEmpty: null,
				query,
				value: []
			};

			query = removeDiacritics(query).toLocaleLowerCase();

			if (data.value) {
				const keywordMatchProperties = [
					'FlightNumber',
					'FlightAirlineName',
					'FlightAirportCode',
					'FlightGate',
					'FlightCity'
				];

				// Loop through each cached flight value
				for (const flight of data.value) {
					// If we have a partial match on the flight number, airline name or city, add it to
					// the filtered results
					for (const property of keywordMatchProperties) {
						if (removeDiacritics(flight[property]).toLocaleLowerCase().includes(query)) {
							filteredData.value.push(flight);
							break;
						}

						if (query in cityMapping) {
							const sub = cityMapping[query];
							if (removeDiacritics(flight[property]).toLocaleLowerCase().includes(sub)) {
								filteredData.value.push(flight);
								break;
							}

						}
					}
				}
			}

			if (!filteredData.value.length) {
				filteredData.isEmpty = true;
			}

			return filteredData;
		} else {
			// If there is no query, just use all the results
			return data;
		}
	}


	/**
	 * Render the flight data using the next-flight template.
	 */
	function renderFlights(data) {
		const script = $('#yvr-flights-template');

		if ($('#yvr-allflights-template').length || $('#yvr-nextflights-template').length) {
			//const template = Handlebars.compile(script.html());

			let template = null;

			if ($('#yvr-allflights-template').length) {
				if (document.documentElement.lang === "fr") {
					template = YVR.templates.flightTableFR;

				} else {
					template = YVR.templates.flightTableEN;
				}
			} else if ($('#yvr-nextflights-template').length) {
				if (document.documentElement.lang === "fr") {
					template = YVR.templates.nextFlightsFR;

				} else {
					template = YVR.templates.nextFlightsEN;
				}
			}


			const html = template(data);

			// Add the table right before the view all link
			$(`.${classes.body}`).html(html);

			// Remove loading class
			$(`.${classes.block}`).removeClass(classes.loading);

			const expandedFlight = elements.block.find(`.${classes.rowExpanded}`);

			if (expandedFlight.length) {
				const offset = ['xs', 'sm'].includes(mq.state) ? $('.yvr-critical-message').outerHeight() : 0;

				$.scrollTo(expandedFlight, {
					duration: 400,
					offset: {
						top: -1 * offset - 20
					}
				});
			}
		}
	}


	/**
	 * Set any event bindings necessary for this component
	 */
	function eventNextFlightsBindings() {
		// Switch between arrivals and departures
		elements.block.on('click', `.${classes.button}`, function () {
			const $this = $(this);

			// Switch the active class modifier
			$(`.${classes.button}--active`).attr('aria-selected', 'false');

			$(`.${classes.button}--active`).removeClass(`${classes.button}--active`);

			$this.addClass(`${classes.button}--active`);
			$this.attr('aria-selected', 'true');
			// Get whether or not this button is arrivals or departures
			options.flightType = $this.data('flight-type');

			runFlights();
		});

		// Go to the arrival or departure page with the flight ID appended
		elements.block.on('click', `.${classes.row}`, function () {
			const id = this.id;
			const form = elements.block.find(`.${classes.form}`);
			const action = form.attr('action');

			if (action && id) {
				window.location.href = `${action}#${id}`;
			}
		});
	}


	/**
	 * Expand a row
	 */
	function expandRow(row) {
		if (!row.hasClass(classes.rowButton) &&
			!row.hasClass('yvr-flight-details') &&
			!['md', 'lg', 'xl'].includes(mq.state)) {
			row.next().toggleClass(classes.rowHidden);
			row.toggleClass(classes.rowExpanded);
		}
	}

	function runFlightSearch() {
		cache.query = elements.block.find(`.${classes.input}`).val();
		cache.date = options.date;

		const data = filterFlightData(cache);
		renderFlights(data);
	}
	function getCookies(cname) {
		let name = cname + '=';
		let decodedCookie = decodeURIComponent(document.cookie);
		let ca = decodedCookie.split(';');
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return '';
	}
	function getFlightCookie() {

		let flight = getCookies('Flight');
		if (flight != '') {
			//console.log(flight);
			//console.log(flightElement.length);
			$('#' + flight).trigger('click');
		}
	}

	/**
	 * Set any event bindings necessary for this component
	 */
	function eventAllFlightsBindings() {
		// Get the new query from the input
		elements.block.on('input keyup', `.${classes.input}`, events.throttle(runFlightSearch, 200));

		// When the search button is clicked
		elements.block.on('click', `.${classes.searchButton}`, e => {
			e.preventDefault();
			runFlightSearch();
		});

		// Toggle a row via button
		elements.block.on('click', `.${classes.collapseButton}`, e => {
			e.preventDefault();
		});

		// Toggle a row
		elements.block.on('click', `.${classes.row}`, function (e) {
			const row = $(this);

			expandRow(row);
		});

		// Expand a row via keyboard
		elements.block.on('keyup', `.${classes.collapseButton}`, function (e) {
			const code = e.keyCode || e.which;

			if (code === 13) {
				const row = $(this);

				expandRow(row);
			}
		});

		// Use the today/tomorrow dropdown link
		elements.block.on('change', `.${classes.toggles}`, function (e) {
			e.preventDefault();
			runFlights();
		});

		// Clear a search by resetting the input
		elements.block.on('click', `.${classes.clearButton}`, e => {
			e.preventDefault();

			elements.block.find(`.${classes.input}`).val('');

			cache.query = '';
			cache.date = options.date;

			const data = filterFlightData(cache);
			renderFlights(data);
		});

		// View earlier flights
		elements.block.on('click', `.${classes.viewEarlier}`, function (e) {
			$(`.${classes.rowEarlier}`).removeClass(classes.rowHidden);

			$(this).parents(`.${classes.row}`).addClass(classes.rowHidden);

			options.showPreviousFlights = false;
			cache.hasEarlierFlights = false;
		});

		// Resize table cell column spans based on the size of the page
		$('html').on(mq.changeEvent, e => {
			if (['setup', 'enter'].includes((e as mq.IMediaQueryEventObject).action) && ['md', 'lg', 'xl'].includes((e as mq.IMediaQueryEventObject).state)) {
				elements.block.find('td[colspan]').attr('colspan', 9);
			} else {
				elements.block.find('td[colspan]').attr('colspan', 6);
			}
		});
	}

	//#endregion

	function bindPassengerJourneyLinks() {
		console.log('bind journey links');
		elements.body.on('click', '[data-journey-href]', function (e) {
			if ($(window).width() >= 768) {
				console.log('clicked ' + $(this).data('journey-href'));
				window.location.href = $(this).data('journey-href');
			} else {
				console.log('small window');
			}
		});
	}

	main();
}
